export const clientVersion = 682